export default __webpack_public_path__ + "static/media/whitepaper.0b49e397.png";